import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const pagetableColumnNumberProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],

  thousandsSeparator: {
    type: Boolean,
    default: true,
  },
  precision: {
    type: Number,
    default: -1,
  },
  percentage: {
    type: Boolean,
    default: false,
  },
})

export type PagetableColumnNumberProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnNumberProps>>>

export default defineComponent({
  name: 'OPagetableColumnNumber',
  inheritAttrs: false,
  props: pagetableColumnNumberProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
